<div class="fundo">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" class="svgTop colorPrimary">
    <path fill-opacity="1" d="M0,288L60,261.3C120,235,240,181,360,181.3C480,181,600,235,720,266.7C840,299,960,309,1080,293.3C1200,277,1320,235,1380,213.3L1440,192L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path>
  </svg>
  <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" class="svgBottom colorPrimary">
    <path fill-opacity="1" d="M0,288L60,261.3C120,235,240,181,360,181.3C480,181,600,235,720,266.7C840,299,960,309,1080,293.3C1200,277,1320,235,1380,213.3L1440,192L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
  </svg> -->
</div>

